
import {
    MDBListGroup,
    MDBListGroupItem,
    MDBBadge,
    MDBBtn,
    MDBIcon,
    MDBInput,
    MDBTabs,
    MDBTabsContent,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsPane,
    MDBSelect

} from "mdb-react-ui-kit";
import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { formattedNumber } from "../../views/popups/phonenumbers/AddRemoveNumbers";
import UIConstant from "../../apiclients/UIConstant";

function PurchasePopupTabs(props) {
    const { t, i18n } = useTranslation();
    const [verticalActive, setVerticalActive] = useState('tab1');

    const handleVerticalClick = (value) => {
        if (value === verticalActive) {
            return;
        }

        setVerticalActive(value);
        props.setTollAdvancedNumbers([]);
        props.setAdvancedNumbers([]);
        props.setsearchType(0);
    };

    const [searchValue, setsearchValue] = useState("");
    const [patternValue, setPatternValue] = useState([]);
    const [areacode, setareacode] = useState(props.areacode != undefined && props.areacode !== "" ? props.areacode : props.defultAreaCode);
    const [error, setError] = useState('');
    const [locationList, setLocationList] = useState([]);
    const [selectLocation, setSelectLocation] = useState(-1);
    const [showSearchOptions, setShowSearchOptions] = useState(true);
    const [addPurchase, setAddPurchase] = useState([]);
    const [areaerror, setAreaError] = useState('');
    const [vanityerror, setVanityError] = useState('');
    const [defaultLocation, setDefaultLocation] = useState('');
    const [isConsecutive, setIsConsecutive] = useState(false);
    const [consecutiveCount, setConsecutiveCount] = useState(2);
    useEffect(() => {
        console.log("are code :::::::: " +typeof(props.areacode),props.areacode);
        // if (props.areacode != undefined && props.areacode !== "") {
        //     setareacode(props.areacode);
        // }
        if (props.locations && props.locations.length > 0) {
            // console.log("location list :::::::::::::: "+JSON.stringify(props.locations));
            const locationNames = props.locations.map((loc) => ({text: loc.loc_name, secondaryText: loc.address, value: loc.loc_id}))
            setLocationList(locationNames);
            // setLocationList(props.locations);

            if (props.selectLocation) {
                setSelectLocation(props.selectLocation ?? -1);
                setDefaultLocation(props.selectLocation ?? -1);
            }
        }
        if (props.addPurchase && props.addPurchase.length > 0) {
            setAddPurchase(props.addPurchase);

        }

        if (props.errorList && props.submitFlag) {
            if (props.errorList.length > 0) {
                props.errorList.forEach((err) => {
                    if (err.fieldname == 'vanity') {
                        setVanityError(err.message)
                    }
                    if (err.fieldname == 'area_code') {
                        setAreaError(err.message);
                    }
                })
            } else {

                setShowSearchOptions(!showSearchOptions);
            }
            props.setSubmitFlag(false);

        }


    }, [props]);

    const handleSearch = (event) => {
        event.preventDefault();
        if (vanityerror !== "") {
            return;
        }
        console.log()
        const update = {
            reqid: 66,
            siteid: JSON.parse(
                sessionStorage.getItem("admin_session")
            ).siteid,
            vanity: searchValue,
            is_tollfree: false,
            is_consecutive_order:isConsecutive,
            quantity_of_consecutive:consecutiveCount
        }
        console.log("handleVanity :::::::: " + JSON.stringify(update));
        props.oSubmit(update, 3);
        // setShowSearchOptions(!showSearchOptions);
    }

    const handlePattern = (event) => {

        event.preventDefault();
        if (areaerror !== "") {
            return;
        }
        const update = {
            reqid: 66,
            siteid: JSON.parse(
                sessionStorage.getItem("admin_session")
            ).siteid,
            pattern: patternValue,
            area_code: parseInt(areacode),
            is_consecutive_order:isConsecutive,
            quantity_of_consecutive:consecutiveCount

        }
        console.log("handlePattern :::::::: " + JSON.stringify(update));
        props.oSubmit(update, 5);
        // setShowSearchOptions(!showSearchOptions);



    }

    const handleLocationSearch = (event) => {
        event.preventDefault();
        console.log("selectLocation :::: " + selectLocation);
        const update = {
            reqid: 66,
            siteid: JSON.parse(
                sessionStorage.getItem("admin_session")
            ).siteid,
            location_id: parseInt(selectLocation),
            is_consecutive_order:isConsecutive,
            quantity_of_consecutive:consecutiveCount
        }

        console.log("handleLocationSearch :::::::: " + JSON.stringify(update));
        props.oSubmit(update, 7);
        // setShowSearchOptions(!showSearchOptions);
    }

    const patternAdd = (event, postion) => {
        event.preventDefault();
        const position = parseInt(postion);
        if (event.target.value !== "") {
            const value = parseInt(event.target.value)
            const index = patternValue.findIndex(item => item.position === position);
            if (index !== -1) {
                // If position exists, update the value
                const updatedPattern = [...patternValue];
                updatedPattern[index].value = value;
                setPatternValue(updatedPattern);
            } else {
                // If position doesn't exist, add a new object to the array

                const newValue = {
                    position: position,
                    value: value,
                }
                setPatternValue([...patternValue, newValue]);
            }
        } else {
            const updatepattern = patternValue.filter(item => item.position !== position);
            setPatternValue(updatepattern);
        }

        const input = event.target;
        const maxLength = parseInt(input.getAttribute('maxlength'), 10);

        if (input.value.length >= maxLength) {
            focusNextInput(postion);
        }

    }

    function changeAreaCode(e, index) {
        e.preventDefault();
        const input = e.target;
        setareacode(input.value);
        props.setSelectAreaCode(input.value);  // Added: Update parent state
        const maxLength = parseInt(input.getAttribute('maxlength'), 10);

        if (input.value.length >= maxLength) {
            focusNextInput(index);
        }
        const newCode = e.target.value;
        // check with empty area code
        if(newCode.trim()===""){
           setAreaError("Area code is required");
            return;
        }
        const codeIndex = props.stateCodeDisplay.findIndex(item => item.area_code == parseInt(newCode));
        if (codeIndex === -1) {
            setAreaError('Invalid area code');

        } else {
            setAreaError('');
        }
    }



    const [hoverNumber, setHoverNumber] = useState("");

    const handleMouseEnter = (phnum) => {
        setHoverNumber(phnum);

    };

    const handleMouseLeave = () => {
        setHoverNumber("");
    };


    // Create refs for each input field
    const inputRefs = [
        useRef(null),

        useRef(null),
        useRef(null),
        useRef(null),

        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
    ];

    // Function to focus on the next input field
    const focusNextInput = index => {
        if (index < inputRefs.length - 1) {
            inputRefs[index + 1].current.focus();
        }
    };

    // Function to focus on the previous input field
    const focusPreviousInput = index => {
        if (index > 0) {
            inputRefs[index - 1].current.focus();
        }
    };


    // Function to handle backspace key press
    const handleBackspace = (e, index) => {
        if (e.keyCode === 8 && e.target.value.length === 0) {
            focusPreviousInput(index);
        }
    };

    const highlightSearchValue = (text, searchPattern, flag) => {
        console.log("Search pattern :::: " + JSON.stringify(searchPattern));
        console.log("Search flag :::: " + flag);

        let highlightedText = text;
        console.log("text :::: " + text);
        if (flag === 5) {

            const sortedSearchpattern = searchPattern.sort((a, b) => b.position - a.position);
            console.log("sortedSearchpattern ::::::::: " + sortedSearchpattern);
            sortedSearchpattern.forEach(({ position, value }) => {
                const pos = parseInt(position) > 3 ? parseInt(position) + 8 : parseInt(position) + 7;
                const digit = text.charAt(pos - 1);
                if (digit === value.toString()) {
                    const before = highlightedText.substring(0, pos - 1);
                    const after = highlightedText.substring(pos);
                    console.log("before ::: " + before);
                    console.log("after ::: " + after);
                    highlightedText = before + '<span class="highlightSearch">' + value + '</span>' + after;
                }
            });
        } else if (flag === 3) {
            const index = text.indexOf(searchPattern);
            let jsonArray = [];
            if (index !== -1) {
                for (let i = 0; i < searchPattern.length; i++) {
                    const position = index + (i + 1);
                    const value = searchPattern[i];
                    jsonArray.push({ position, value });
                }
            }

            const sortedSearchpattern = jsonArray.sort((a, b) => b.position - a.position);
            let formattedNumber = "";
            if (text.length === 10) {
                const countryCode = '+1';
                const areaCode = text.substring(0, 3);
                const exchangeCode = text.substring(3, 6);
                const remainingDigits = text.substring(6);

                // Format the E.164 number
                formattedNumber = `${countryCode} ${areaCode} ${exchangeCode} ${remainingDigits}`;
            } else if (text.length === 11) {
                const countryCode = '+1';
                const areaCode = text.substring(1, 4);
                const exchangeCode = text.substring(4, 7);
                const remainingDigits = text.substring(7);
                formattedNumber = `${countryCode} ${areaCode} ${exchangeCode} ${remainingDigits}`;
            }
            sortedSearchpattern.forEach(({ position, value }) => {
                const posit = parseInt(position);
                const textlength = text.length;
                let pos;
                if (textlength === 11) {
                    pos = posit === 1 ? (posit + 1) : posit > 1 && posit < 5 ? (posit + 2) : posit > 4 && posit < 8 ? (posit + 3) : (posit + 4);

                } else if (textlength === 10) {
                    pos = posit > 0 && posit < 4 ? (posit + 3) : posit > 3 && posit < 7 ? (posit + 4) : (posit + 5);
                }

                const digit = formattedNumber.charAt(pos - 1);
                if (digit === value.toString()) {
                    const before = formattedNumber.substring(0, pos - 1);
                    const after = formattedNumber.substring(pos);
                    console.log("before ::: " + before);
                    console.log("after ::: " + after);
                    formattedNumber = before + '<span class="highlightSearch">' + value + '</span>' + after;
                }
            });
            highlightedText = formattedNumber;
        }
        console.log("highlightedText ::::::: " + highlightedText);

        return highlightedText;
    };

    const handleAddButton = (e, phoneNumber, isSMS, isTollFree,province,lata,api,tnReserve) => {
        e.preventDefault();
        e.stopPropagation();

        const PhIndex = addPurchase.findIndex(number => number.phone_number === phoneNumber);
        let updatedNumbers;
        if (PhIndex === -1) {
            let number = {
                phone_number: phoneNumber,
                is_sms_enabled: isSMS,
                is_toll_free: isTollFree,
                province: province,
                lata :lata,
                api : api ? api : false,
                tnReserve:tnReserve ? tnReserve : false
            }

            updatedNumbers = [...addPurchase, number];
        } else {
            updatedNumbers = addPurchase.filter(number => number.phone_number !== phoneNumber);
        }
        setAddPurchase(updatedNumbers);
        props.setAddPurchase(updatedNumbers);

    };
    // Function to clear all input values
    const clearInputValues = () => {
        
        inputRefs.forEach((ref, index) => {
            if(index === 0) {
            ref.current.value = props.existAreaCode ? props.existAreaCode : ''; // Clear the value of each input field
            } else {
                ref.current.value = ''; // Clear the value of each input field
            }
        });
        setareacode(props.existAreaCode ? props.existAreaCode : "");
        setAreaError("")
        setIsConsecutive(false);
        setConsecutiveCount(2);
        // setareacode(existAreaCode);
    };

    return (
        <>

            {showSearchOptions && (
                <>

                    <div className="d-flex justify-content-between align-items-center pb-2">
                        <div className="general-settings">Advanced Search</div>
                        <MDBBtn onClick={props.toggleAdvancedSearch} color="light">
                            <MDBIcon fas icon="times" className="fs-5" />
                        </MDBBtn>
                    </div>


                    <MDBTabs className="pb-3">
                        <MDBTabsItem>
                            <MDBTabsLink onClick={() => handleVerticalClick('tab1')} active={verticalActive === 'tab1'}>
                                Vanity
                            </MDBTabsLink>
                        </MDBTabsItem>
                        <MDBTabsItem>
                            <MDBTabsLink onClick={() => handleVerticalClick('tab2')} active={verticalActive === 'tab2'}>
                                Pattern
                            </MDBTabsLink>
                        </MDBTabsItem>
                        <MDBTabsItem>
                            <MDBTabsLink onClick={() => handleVerticalClick('tab3')} active={verticalActive === 'tab3'}>
                                Location
                            </MDBTabsLink>
                        </MDBTabsItem>
                    </MDBTabs>
                    {/* </MDBCol> */}
                    {/* <MDBCol size='9' className="acc-body"> */}
                    <MDBTabsContent className="h-100 tab-height">
                        <MDBTabsPane open={verticalActive === 'tab1'}>

                            <div>
                                <div className="d-flex align-items-start justify-content-between pb-3">
                                    <div className="tel-numbers d-flex flex-column">
                                        <b>
                                            {t("Vanityphrase")}
                                        </b>
                                        <span className="text-secondary text-small">
                                            To choose placement, use pattern search
                                        </span>
                                    </div>


                                    <div className="phoneselect w-40">

                                        <div className="form-outline">
                                        <input type="text" className="form-control" value={searchValue} onChange={(e) => {
                                                if (e.target.value.length > 7) {
                                                    setVanityError("Maximum 7 characters allowed");
                                                } else if (e.target.value.toString().startsWith("0")){
                                                    setVanityError("Should not start with zero");
                                                } else if (e.target.value.length > 0 && e.target.value.length < 4) {
                                                    setVanityError("Minimum 4 characters");
                                                } else {
                                                    setVanityError("");
                                                }
                                                setsearchValue(e.target.value.toUpperCase());
                                            }}
                                            placeholder='E.g. "Bus","1234"'
                                            // maxLength={7}
                                            />
                                            {vanityerror && <div style={{ color: 'red' }}>{vanityerror}</div>}


                                        </div>
                                    </div>
                                </div>
                                <div className="add-numbermain noHoverBg m-0 px-0">
                                    <p className="me-2">Request multiple phone numbers in consecutive order</p>
                                    <label className="switch">
                                        <input
                                            className="form-control"
                                            type="checkbox"
                                            checked={isConsecutive}
                                            onChange={(e) => setIsConsecutive(!isConsecutive) }
                                        />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                                {isConsecutive &&
                                    <>
                                        <div className="add-numbermain noHoverBg m-0 px-0">
                                            <div className="tel-numbers">
                                                Quantity of consecutive numbers (max: {UIConstant.MAX__CONSECUTIVE_NUMBERS}) <br />
                                                <span className="phrecording text-secondary">
                                                    Only show numbers grouped in this minimum quantity
                                                </span>
                                            </div>

                                            <div className="d-flex align-items-center justify-content-center">
                                                <div className="d-flex align-items-center border rounded" style={{ width: "120px", justifyContent: "space-between" }}>
                                                    <MDBBtn size="sm" color="light"
                                                        disabled={consecutiveCount <= 2}
                                                        onClick={() => {
                                                            setConsecutiveCount((prev) => Math.max(prev - 1, 2));
                                                        }}
                                                    >
                                                    <MDBIcon fas icon="minus" />

                                                    </MDBBtn>
                                                    <span>{consecutiveCount}</span>
                                                    <MDBBtn size="sm" color="light"
                                                        disabled={consecutiveCount >= UIConstant.MAX__CONSECUTIVE_NUMBERS}
                                                        onClick={() => {
                                                            setConsecutiveCount((prev) => Math.min(prev + 1, UIConstant.MAX__CONSECUTIVE_NUMBERS));
                                                        }}
                                                    >
                                                    <MDBIcon fas icon="plus" />

                                                    </MDBBtn>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                                <div className="d-flex py-2 justify-content-between mt-3">
                                    <MDBBtn color="secondary" onClick={(e) => {
                                        e.preventDefault();
                                        setsearchValue("");
                                        setIsConsecutive(false);
                                        setConsecutiveCount(2);
                                    }}>Reset</MDBBtn>
                                    <div>
                                        <MDBBtn className="me-2" color="secondary" onClick={props.toggleAdvancedSearch}>Cancel</MDBBtn>
                                        <a href="#SearchResultsPattern">
                                            <MDBBtn onClick={(e) => handleSearch(e)}>Search</MDBBtn>
                                        </a>
                                    </div>
                                </div>

                            </div>

                        </MDBTabsPane>
                        <MDBTabsPane open={verticalActive === 'tab2'}>
                            <div className="tel-numbers">
                                <b>
                                    {t("Patternsearch")}
                                </b>
                                <br />
                                <span className="phrecording">
                                    Enter any combination of numbers or letters (regional code is required)
                                </span>

                                <div className="d-flex align-items-start my-3">
                                    <div className="me-2 w-50">
                                        <MDBInput
                                            placeholder={areacode}
                                            type="text"
                                            className="text-center"
                                            maxLength={3}
                                            ref={inputRefs[0]}
                                            value={areacode}
                                            onChange={e => changeAreaCode(e, 0)}
                                            onKeyDown={e => handleBackspace(e, 0)}
                                        />
                                        {areaerror && <div style={{ color: 'red' }}>{areaerror}</div>}
                                    </div>
                                    <span className="me-2 mt-2">-</span>
                                    {inputRefs.slice(1).map((ref, index) => (
                                        <>
                                            {index === 3 && (
                                                <span className="me-2 mt-2">-</span>
                                            )}
                                            <div key={index} className="me-2">
                                                <MDBInput
                                                    placeholder="*"
                                                    type="text"
                                                    className="text-center"
                                                    maxLength={1}
                                                    ref={ref}
                                                    onKeyPress={(event) => {
                                                        if (!/[0-9]/.test(event.key)) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                    onChange={e => patternAdd(e, index + 1)}
                                                    onKeyDown={e => handleBackspace(e, index + 1)}
                                                />
                                            </div>
                                        </>
                                    ))}
                                </div>


                                <span className="phrecording d-block" >
                                    <b>
                                        Pattern Search Instructions:
                                    </b>
                                    <ol>
                                        <li>
                                            Enter any combination of numbers or letters in the available boxes.
                                        </li>
                                        <li>
                                            You don't have to fill out all the boxes.
                                        </li>
                                        <li>
                                        For the best results, fill out as few boxes as possible.
                                        </li>
                                    </ol>
                                </span>
                            </div>


                            <div className="add-numbermain noHoverBg m-0 px-0">
                                    <p className="me-2">Request multiple phone numbers in consecutive order</p>
                                    <label className="switch">
                                        <input
                                            className="form-control"
                                            type="checkbox"
                                            checked={isConsecutive}
                                            onChange={(e) => setIsConsecutive(!isConsecutive)}
                                        />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            {isConsecutive &&
                                <>
                                    <div className="add-numbermain noHoverBg m-0 px-0">
                                        <div className="tel-numbers">
                                            Quantity of consecutive numbers (max: {UIConstant.MAX__CONSECUTIVE_NUMBERS}) <br />
                                            <span className="phrecording text-secondary">
                                                Only show numbers grouped in this minimum quantity
                                            </span>
                                        </div>

                                        <div className="d-flex align-items-center justify-content-center">
                                            <div className="d-flex align-items-center border rounded" style={{ width: "120px", justifyContent: "space-between" }}>
                                                <MDBBtn size="sm" color="light"
                                                    disabled={consecutiveCount <= 2}
                                                    onClick={() => {
                                                        setConsecutiveCount((prev) => Math.max(prev - 1, 2));
                                                    }}
                                                >
                                                <MDBIcon fas icon="minus" />
                                                </MDBBtn>
                                                <span>{consecutiveCount}</span>
                                                <MDBBtn size="sm" color="light"
                                                    disabled={consecutiveCount >= UIConstant.MAX__CONSECUTIVE_NUMBERS}
                                                    onClick={() => {
                                                        setConsecutiveCount((prev) => Math.min(prev + 1, UIConstant.MAX__CONSECUTIVE_NUMBERS));
                                                    }}
                                                >
                                                <MDBIcon fas icon="plus" />

                                                </MDBBtn>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                            <div className="d-flex py-2 justify-content-between">
                                <MDBBtn color="secondary" onClick={clearInputValues}>Reset</MDBBtn>
                                <div>
                                    <MDBBtn className="me-2" color="secondary" onClick={props.toggleAdvancedSearch} >Cancel</MDBBtn>
                                    <MDBBtn onClick={handlePattern}>Search</MDBBtn>
                                </div>
                            </div>
                        </MDBTabsPane>
                        <MDBTabsPane open={verticalActive === 'tab3'}>

                            <div className="tel-numbers pb-3">
                                <b>
                                    {t("location")}
                                </b>
                                <br />
                                <span className="phrecording">
                                    Only show numbers that match the selected location's regional code
                                </span>
                            </div>
                            <div className="phoneselect width-100">
                                <MDBSelect className="w-100" data = {[{text: "Select Location", value: -1}, ...locationList]}  search value={selectLocation} onChange={(e) => {
                                    if(e && e.value) {
                                    // e.preventDefault();
                                    props.setSelectLocation(e.value);
                                    setSelectLocation(e.value)
                                    }
                                }}
                                />
                                {selectLocation == -1  && <div className="text-start text-danger" >Location is required</div>}

                                    {/* {locationList && locationList.length > 0 && locationList.map((loc) => (
                                        <option value={loc.loc_id} key={loc.loc_id}>{loc.address}</option>

                                    ))}
                                </MDBSelect> */}
                            </div>
                            {/* <div className="text-end mt-2">
                                <MDBBtn color='tertiary' rippleColor='light' onClick={toggleOpen}><MDBIcon fas icon="plus" className="me-2" /> Add New Location</MDBBtn>
                            </div> */}
                            <div className="add-numbermain noHoverBg m-0 px-0">
                                <p className="me-2">Request multiple phone numbers in consecutive order</p>
                                <label className="switch">
                                    <input
                                        className="form-control"
                                        type="checkbox"
                                        checked={isConsecutive}
                                        onChange={(e) => setIsConsecutive(!isConsecutive)}
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                            {isConsecutive &&
                                <>
                                        <div className="add-numbermain noHoverBg m-0 px-0">
                                            <div className="tel-numbers">
                                                Quantity of consecutive numbers (max: {UIConstant.MAX__CONSECUTIVE_NUMBERS}) <br />
                                                <span className="phrecording text-secondary">
                                                    Only show numbers grouped in this minimum quantity
                                                </span>
                                            </div>

                                            <div className="d-flex align-items-center justify-content-center">
                                        <div className="d-flex align-items-center border rounded" style={{ width: "120px", justifyContent: "space-between" }}>
                                            <MDBBtn size="sm" color="light"
                                                disabled={consecutiveCount <= 1}
                                                onClick={() => {
                                                    setConsecutiveCount((prev) => Math.max(prev - 1, 2));
                                                }}
                                            >
                                                <MDBIcon fas icon="minus" size="md"/>
                                            </MDBBtn>
                                            <span>{consecutiveCount}</span>
                                            <MDBBtn size="sm" color="light"
                                                disabled={consecutiveCount >= UIConstant.MAX__CONSECUTIVE_NUMBERS}
                                                onClick={() => {
                                                    setConsecutiveCount((prev) => Math.min(prev + 1, UIConstant.MAX__CONSECUTIVE_NUMBERS));
                                                }}
                                            >
                                                <MDBIcon fas icon="plus" size="md"/>
                                            </MDBBtn>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            <div className="d-flex py-2 justify-content-between mt-2">
                                <MDBBtn color="secondary" onClick={(e) => {
                                    e.preventDefault();
                                    setSelectLocation(-1);
                                    setIsConsecutive(false);
                                    setConsecutiveCount(2);
                                }}>Reset</MDBBtn>
                                <div>
                                    <MDBBtn className="me-2" color="secondary" onClick={props.toggleAdvancedSearch}>Cancel</MDBBtn>
                                    <MDBBtn onClick={handleLocationSearch}>Search</MDBBtn>
                                </div>
                            </div>

                        </MDBTabsPane>
                    </MDBTabsContent>

                </>
            )}



            {!showSearchOptions &&
                <div>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex">
                            <MDBBtn onClick={props.searchType === 3 ? handleSearch : props.searchType === 5 ? handlePattern : handleLocationSearch} color="light" className="me-3">
                                <MDBIcon fas icon="arrow-left" className="fs-5" />
                            </MDBBtn>
                            <div className="general-settings">Results</div>
                        </div>
                        <MDBBtn onClick={props.toggleAdvancedSearch} color="light">
                            <MDBIcon fas icon="times" className="fs-5" />
                        </MDBBtn>
                    </div>
                    <div>


                        <div>
                            <MDBListGroup light className="list-view h-30">
                                {props.advancedNumbers.length > 50 && (
                                    <p>
                                        50 numbers of many
                                    </p>
                                )}

                                {props.advancedNumbers && props.advancedNumbers.length > 0 ? (
                                    props.advancedNumbers.map(result => (
                                        <MDBListGroupItem key={result.phone_number} className='d-flex justify-content-between align-items-center'>
                                            <div className="d-flex align-items-center">
                                                <div>
                                                    <div className="d-flex align-items-center">
                                                        <div dangerouslySetInnerHTML={{ __html: highlightSearchValue((props.searchType === 3 ? result.display_phone_number : formattedNumber(result.phone_number)), props.advacedSearchType, props.searchType) }} />
                                                        {result.is_sms_enabled === 1 && (
                                                            <MDBBadge color="primary" title="SMS Capable" className="fw-400"><MDBIcon far icon="comment-alt" /></MDBBadge>
                                                        )}
                                                    </div>
                                                    {/* <div className='text-muted'>Debary, FL</div> */}
                                                </div>
                                            </div>
                                            <MDBBtn
                                                size="sm"
                                                color={addPurchase.some(item => item.phone_number === result.phone_number) ? (hoverNumber === result.phone_number ? 'danger' : 'success') : 'primary'}
                                                onClick={(e) => handleAddButton(e, result.phone_number, result.is_sms_enabled, false,result.province,result.lata,result?.api ?? false,result.tnReserve)}
                                                onMouseEnter={() => handleMouseEnter(result.phone_number)} // Call the function
                                                onMouseLeave={() => handleMouseLeave()} // Call the function
                                                className="shadow-0"
                                            >
                                                <MDBIcon
                                                    fas
                                                    icon={addPurchase.some(item => item.phone_number === result.phone_number) ? (hoverNumber === result.phone_number ? 'times' : 'check') : 'plus'}
                                                    color="white"
                                                    style={{ fontSize: 10 }}
                                                />
                                                <span className={addPurchase.some(item => item.phone_number === result.phone_number) ? `ms-2 text-light w-40px` : `ms-2 text-light`} style={{ fontSize: 11, width: "50px" }}>
                                                    {addPurchase.some(item => item.phone_number === result.phone_number) ? (hoverNumber === result.phone_number ? 'Remove' : 'Added') : 'Add'}
                                                </span>
                                            </MDBBtn>
                                        </MDBListGroupItem>
                                    ))
                                ) : (
                                    <div className="text-center">
                                        No Records found
                                    </div>
                                )}
                            </MDBListGroup>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}
export default PurchasePopupTabs